import React from 'react';
export const VOUCHED_LOCKUP_SRC = {
    blue: 'assets/vouched-lockup-blue.png',
    white: 'assets/vouched-lockup-white.png'
};
export const VouchedLogo = ({ variant, width, maxWidth }) => (React.createElement("img", { alt: "Vouched", src: VOUCHED_LOCKUP_SRC[variant], style: {
        display: 'block',
        height: 'auto',
        margin: '0 auto',
        maxWidth,
        width
    } }));
